import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { dmApi } from "./dmApi";
import { thunk } from "redux-thunk";
import globalSlice from "./globalSlice";
import { sliceNames } from "../helpers/constants";

const rootReducers = combineReducers({
    // reset: resetReducers,
    [sliceNames.GLOBAL]: globalSlice,
    [dmApi.reducerPath]: dmApi.reducer,

})
const store = configureStore({
    reducer: rootReducers,
    // middleware: [logger, thunk]
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ thunk: false }).concat(thunk, dmApi.middleware)
    // getDefaultMiddleware().concat(dmApi.middleware).concat(thunk)
    // getDefaultMiddleware().concat(addyApi.middleware).concat(logger).concat(thunk)
});

// Enable refetchOnFocus and refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;
